<template>
    <div style="min-height: 500px;">
        <div class="record_box">
            <div class="header">
                <div class="left">
                    <div class="prev-css icon iconfont icon-zuojiantou" @click="prev"></div>
                    {{headerContent}}
                    <div class="prev-css icon iconfont icon-youjiantou" @click="next"></div>
                </div>
            </div>
            <div class="body">
                <!-- 生成一个周 时间列表 -->
                <table class="week-table" cellspacing="0" cellpadding="0" >
                    <thead>
                    <th style="height: 60px; border: 1px solid #EBEEF5;">时间</th>
                    <th style="height: 60px;border: 1px solid #EBEEF5;" v-for="(header, index) in weekTableHeader"
                        :key="index" :class="header.class">{{header.date}}
                    </th>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in list" :key="index" style="height: 70px;">
                        <td>
                            <div class="hours">
                                <span>{{item.name}}</span>
                            </div>
                        </td>
                        <td v-for="(dateList, dateListIndex) in item.dateList" class="hand-css">
                            <div class="dateList">
                                <div class="dateItem" v-for="(date, dateIndex) in dateList" @click="getDateLog(date)">
                                    <span :class="date.is_read == 1 ? 'read' : 'unread'"></span>
                                    <span>{{date.type_name}}</span>
                                    <span v-if="date.is_read == 1">（已读）</span>
                                    <span v-else>（未读）</span>
                                </div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
		<Modal v-model="recordModal" width="1200" title="日志">
			<Record :id = "log_id"></Record> 
		</Modal>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import {getReportDateList,getDateLog} from '@/api/task'
	import Record from './components/Record.vue'
    import moment from "moment";

    export default {
        name: "RecordList",
        computed:{
            ...mapGetters(['userInfo', 'token']),
        },
		components:{
			Record
		},
        created() {
            // v-show是在创建后 保留dom 只是做切换的 不会v-if那样 销毁dom 所以只需要创建一次
            this.createCalendar()
            let weekday = moment().weekday() === 0 ? 7 : moment().weekday()
            let daysDistance = 1 - weekday
            this.currentWeekday = moment().add(daysDistance, 'days')
            this.createWeekList()
            this.getList();
        },
        data() {
            return {
				recordModal:false,
				log_id:'',
                list: [],
                today: moment().format('YYYY-MM-DD'),
                currentYearMonth: moment().format('YYYY-MM'),
                weekTableHeader: [],
                dates: [],
                showMonth: false,
                weekList: [],
                //初始化页面显示的东西
                headerContent: moment().format('YYYY-MM'),
            }
        },
        methods: {
            ...mapActions([
                'getUserInfo',
            ]),
            async getList() {
                let that = this;
                that.list = [];
                let data = {token: that.token, dateTime: that.weekTableHeader}
                let res = await getReportDateList(that, data);
                if (res.code == 1) {
                    that.list = res.data.list;
					console.log(that.list)
                }
            },
			async getDateLog(date){
				let that = this;
				that.log_id = date.id;
				this.recordModal = true;
			},
            // 点击上个月 通过改变currentYearMonth来获取上个月的 YYYY-MM 格式
            prev() {
                if (this.showMonth) {
                    this.currentYearMonth = moment(this.currentYearMonth).subtract(1, 'months').format('YYYY-MM')
                    this.headerContent = this.currentYearMonth
                    this.createCalendar()
                } else {
                    this.currentWeekday = moment(this.currentWeekday).subtract(7, 'days')
                    this.weekHeaderContent()
                    this.createWeekList()
                }
                this.getList();
            },
            next() {
                if (this.showMonth) {
                    this.currentYearMonth = moment(this.currentYearMonth).add(1, 'months').format('YYYY-MM')
                    this.headerContent = this.currentYearMonth
                    this.createCalendar()
                } else {
                    this.currentWeekday = moment(this.currentWeekday).add(7, 'days')
                    this.weekHeaderContent()
                    this.createWeekList()
                }
                this.getList();
            },
            createCalendar() {
                this.dates = []
                // 获取当月的一号是星期几 以便来生成上月的日期 填补够42个格子
                const monthFirstDay = moment(this.currentYearMonth + '-01', 'YYYY-MM-DD')
                // 获得一号与第一个格子内应该有的天数距离 这里需要注意的是 weekday 是从周日 为 0 开始的
                let firstDayWeekday = moment(monthFirstDay).weekday()
                if (firstDayWeekday === 0) {
                    firstDayWeekday = 7
                }
                let daysDistance = 1 - firstDayWeekday
                for (let weeks = 0; weeks < 5; weeks++) {
                    this.dates.push([])
                    for (let weekday = 0; weekday < 7; weekday++) {
                        // 该对象有两个属性 一个是class属性 还有一个就是日期
                        let date = {}
                        date.day = moment(monthFirstDay).add(daysDistance, 'days')
                        date.value = date.day.format('YYYY-MM-DD')
                        date.isAlive = ''
                        const dayMonth = moment(date.day).month()
                        // 是这个月的日期
                        if (dayMonth === moment(monthFirstDay).month()) {
                            date.class = 'current-month '
                            // 日期是今天的高亮
                            if (moment(date.day).isSame(this.today, 'days')) {
                                date.class += 'today '
                            }
                        } else {
                            date.class = 'not-current-month '
                        }
                        date.day = moment(date.day).format('DD')
                        this.dates[weeks].push(date)
                        daysDistance++
                    }
                }
            },
            createWeekList() {
                this.weekTableHeader = ['周一 ', '周二 ', '周三 ', '周四 ', '周五 ', '周六 ', '周日 ']
                this.weekList = []
                for (let index = 0; index < 7; index++) {
                    let item = {}
                    item.date = moment(this.currentWeekday).add(index, 'days')
                    if (item.date.isSame(this.today, 'days')) {
                        item.class = 'today'
                    }
                    item.value = item.date.format('YYYY-MM-DD');
                    item.date = this.weekTableHeader[index] + item.date.format('MM/DD')
                    this.weekTableHeader[index] = item
                }
            },
            weekHeaderContent() {
                this.headerContent = moment(this.currentWeekday).format('YYYY-MM')
            }

        }
    }
</script>

<style scoped lang="less">
    .prev-css {
        color: #277dd3;
        font-size: 30px;
        cursor: pointer;
    }

    .left {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .hand-css {
        cursor: pointer;
    }

    .journeytext {
        color: #999999;
        text-decoration: line-through
    }

    .checkcss {
        color: #FF0000;
        text-decoration: none
    }

    .yuanlan {
        height: 7px;
        width: 7px;
        border-radius: 50%;
        margin: 0 1px;
        padding-right: 5px;
    }

    .bg-blue {
        background-color: #277dd3;
    }

    .bg-pink {
        background-color: rgb(255, 141, 141)
    }

    .bg-green {
        background-color: rgb(0, 163, 178);
    }

    .scrollbar-css::-webkit-scrollbar {
        width: 5px;
        height: 4px;
        background-color: #f5f5f5;
    }

    .scrollbar-css::-webkit-scrollbar-thumb {
        border-radius: 3px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, .2);
        background: #cae1f5;
    }

    .scrollbar-css::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
        background: #fff;
    }

    .fill {
        font-size: 15px;
        margin-left: 5px;
        color: #277dd3;
    }

    .fill-month {
        font-size: 15px;
        color: #277dd3;
    }

    #parent {
        margin: 0 auto;
    }

    .header {
        display: flex;
        justify-content: space-between;
        padding: 12px 20px;
        font-size: 18px;
    }

    .body {
        padding: 12px 20px 35px;
    }

    table {
        table-layout: fixed;
        width: 100%;
    }

    table thead th {
        padding: 10px 0;
        font-weight: 400;
    }

    tbody tr {
        display: table-row;
        vertical-align: inherit;
        border-color: inherit;
    }

    .month-table tbody td {
        vertical-align: inherit;
        border-right: 1px solid #ebeef5;
        border-bottom: 1px solid #ebeef5;
    }

    .month-table tbody tr:first-child td {
        border-top: 1px solid #ebeef5;
    }

    .month-table tr td:first-child {
        border-left: 1px solid #ebeef5;
    }

    .date {
        box-sizing: border-box;
        padding: 8px;
        height: 160px;
        overflow: auto;
    }

    .date::-webkit-scrollbar {
        width: 5px;
        height: 4px;
        background-color: #f5f5f5;
    }

    .date::-webkit-scrollbar-thumb {
        border-radius: 3px;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, .2);
        background: #cae1f5;
    }

    .date::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
        background: #fff;
    }

    .not-current-month {
        color: #909399;
    }

    .current-month {
        color: #000000;
    }

    .today {
        color: #000000;
        background-color: #F5FBFF;
    }

    .date-alive {
        background-color: rgb(252, 212, 215);
    }

    .week-table tbody tr td {
        border: 1px solid #ebeef5;
    }

    .team-title {
        width: 90px;
        height: 40px;
        background-color: #F8F9FB;
        text-align: center;
        line-height: 40px;
        border-right: 1px solid #EBECEF;
    }

    .team-tabel {
        // width: 1530px;
        margin: 0 auto;
        border-left: 1px solid #EBECEF;
        border-top: 1px solid #EBECEF;
        border-bottom: 1px solid #EBECEF;
    }
    .record_box {
        height: 690px;
        overflow: scroll;
    }

    .record_box::-webkit-scrollbar {
        width: 5px;
        height: 4px;
        background-color: #f5f5f5;
    }

    .record_box::-webkit-scrollbar-thumb {
        border-radius: 3px;
        background-color: #cae1f5;
    }

    .record_box::-webkit-scrollbar-track {
        background-color: #eeeeee;
    }
    .hours{
        text-align: center;
    }
    .dateList{
        display: flex;
        /*垂直排列*/
        flex-direction: column;
        align-items:center;/*由于flex-direction: column，因此align-items代表的是水平方向*/
        justify-content: center;/*由于flex-direction: column，因此justify-content代表的是垂直方向*/
    }
    .dateItem{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .read{
            width:12px;height:12px;border-radius:50%;background-color:#2A8BF6;margin-bottom: 2px;margin-right: 3px;
        }
        .unread{
            width:12px;height:12px;border-radius:50%;background-color:red;margin-bottom: 2px;margin-right: 3px;
        }
    }
</style>
